import { AuthEnums } from "models/enums";
import { ArticleFormTypes } from "models/formTypes";
import { WintSuperkollAPIModel, WintUtilsWebApi, WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import useAPIClientHelper from "./useAPIClientHelper";

function useArticleService() {
  const { apiClientInstance } = useAPIClientHelper();

  const get = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .ArticleClient.GetById(id)
      .then((res) => res.data);
  };
  const deleteArticle = (id: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true })
      .ArticleClient.Delete(id)
      .then((res) => res.data);
  };
  const filter = (filter: ApiModels.ArticleFilter, skipUndefinedConversion?: boolean) => {
    return apiClientInstance(AuthEnums.AuthType.Company, {
      skipUndefinedConversion: skipUndefinedConversion,
    }).ArticleClient.GetByFilter(filter);
  };
  const update = (id: number, article: WintSuperkollAPIModel.ArticlePut) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true }).ArticleClient.Put(id, article);
  };
  const create = (article: WintSuperkollAPIModel.ArticlePost) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true }).ArticleClient.Post(article);
  };
  const importArticles = (importDetails: WintSuperkollAPIModel.ArticleImportRequest) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true }).ArticleClient.ImportArticles(
      importDetails
    );
  };

  const reportToAPIFilter = (
    formFilter?: ArticleFormTypes.Filter
  ): Omit<ApiModels.ArticleFilter, keyof WintUtilsWebApi.Filter> => {
    return {
      name: formFilter?.name,
      euVatProductType: formFilter?.euVatProductType?.map(
        (euVat) => euVat.id as WintSuperkollAPIModel.EuVatProductType
      ),
      totalAmountForLastYearlyPeriodFrom: formFilter?.totalAmountForLastYearlyPeriod?.lowest,
      totalAmountForLastYearlyPeriodTo: formFilter?.totalAmountForLastYearlyPeriod?.highest,
      totalQuantityForLastYearlyPeriodFrom: formFilter?.totalQuantityForLastYearlyPeriod?.lowest,
      totalQuantityForLastYearlyPeriodTo: formFilter?.totalQuantityForLastYearlyPeriod?.highest,
      unitPriceFrom: formFilter?.unitPrice?.lowest,
      unitPriceTo: formFilter?.unitPrice?.highest,
      unitId: formFilter?.unitId,
      updatedAfter: formFilter?.updatedAfter,
      inactive: formFilter?.active !== undefined ? !formFilter.active : undefined,
    };
  };

  const reportFilter = (
    baseFilter: WintUtilsWebApi.Filter,
    formFilter?: ArticleFormTypes.Filter,
    skipUndefinedConversion?: boolean
  ) => {
    return filter(
      {
        ...baseFilter,
        ...reportToAPIFilter(formFilter),
      },
      skipUndefinedConversion
    );
  };

  return {
    get,
    filter,
    deleteArticle,
    update,
    create,
    reportToAPIFilter,
    reportFilter,
    importArticles,
  };
}

export default useArticleService;
